(() => {
  const cueSelector = '[data-product-card-click-cue]';
  const randomizeProductCardCues = (root = document) => {
    const images = [];
    if (root instanceof Element && root.matches(cueSelector)) images.push(root);
    images.push(...root.querySelectorAll(cueSelector));

    images.forEach((image) => {
      const assets = image.dataset.cueAssets?.split('|').filter(Boolean);
      if (!assets?.length) return;
      image.src = assets[Math.floor(Math.random() * assets.length)];
    });
  };

  randomizeProductCardCues();

  const initializeCountdowns = (root = document) => {
    const countdowns = [];
    if (root instanceof Element && root.matches('[data-halloween-countdown]')) countdowns.push(root);
    countdowns.push(...root.querySelectorAll('[data-halloween-countdown]'));

    countdowns.forEach((countdown) => {
      if (countdown.dataset.initialized === 'true') return;
      countdown.dataset.initialized = 'true';
      const endTime = new Date(countdown.dataset.endDate).getTime();
      const time = countdown.querySelector('[data-countdown-time]');
      const expired = countdown.querySelector('[data-countdown-expired]');
      const fields = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]'),
      };
      if (!Number.isFinite(endTime) || Object.values(fields).some((field) => !field) || !time || !expired) return;

      let intervalId;
      const update = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        fields.days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
        fields.hours.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
        fields.minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        fields.seconds.textContent = String(totalSeconds % 60).padStart(2, '0');

        if (remaining === 0) {
          time.hidden = true;
          expired.hidden = false;
          window.clearInterval(intervalId);
        }
      };

      update();
      intervalId = window.setInterval(update, 1000);
      countdown.countdownIntervalId = intervalId;
    });
  };

  initializeCountdowns();
  document.addEventListener('shopify:section:load', (event) => {
    randomizeProductCardCues(event.target);
    initializeCountdowns(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const countdowns = [];
    if (event.target instanceof Element && event.target.matches('[data-halloween-countdown]')) countdowns.push(event.target);
    countdowns.push(...event.target.querySelectorAll('[data-halloween-countdown]'));
    countdowns.forEach((countdown) => window.clearInterval(countdown.countdownIntervalId));
  });

  if (!window.halloweenSidekickCloseBound) {
    window.halloweenSidekickCloseBound = true;
    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-halloween-sidekick-close]');
      if (!closeButton) return;

      const sidekick = closeButton.closest('[data-halloween-sidekick]');
      if (!sidekick) return;

      sidekick.hidden = true;
    });
  }
})();
